import request from '@/utils/request'

export function findGeoLocations(findRequest) {
  return request({
    url: '/location/findlocations',
    method: 'post',
    data: findRequest,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

export function getDataSection(query) {
  return request({
    url: '/location/GetDataSection',
    method: 'post',
    data: query,
    timeout: 60000,
    headers: {
      'Content-Type': 'application/json'
    }
  })
}

